import { useSelector } from "react-redux";
import { ProgressStepper } from "@/components/CommonComponents/ProgressStepper";
// @ts-expect-error: ignoring as it is existing js file
import { applicationSelector } from "@/store/slices/applicationFormSlice";
import type { ApplicationFormSlice, ApplicationState, SubmissionStep } from "@/store/slices/types/applicationFormSlice";

interface SubmissionStepperProps {
  activeStep: SubmissionStep["type"];
}

const SubmissionStepper = ({ activeStep }: SubmissionStepperProps) => {
  const { submissionModal } = useSelector<ApplicationFormSlice, ApplicationState>(applicationSelector);

  return (
    <ProgressStepper
      activeStep={activeStep}
      steps={submissionModal.steps.map(({ type, stepper, isCompleted }) => ({
        key: type,
        label: stepper,
        isCompleted,
      }))}
    />
  );
};

export { SubmissionStepper };
